import axios from "axios";

const API = axios.create({
  baseURL: "https://vaultsphere-backend.onrender.com/api",
});

// ── Attach token to every request ──
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

// ── Auto-handle 401: clear and redirect ──
API.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default API;